import { createSlice } from '@reduxjs/toolkit';
import { fetchSYear } from '../action/syearAction';
const initialState = {
    syears: [],
    isLoaderYear: false
};
export const yearSSlice = createSlice({
    initialState,
    name: 'year',
    reducers: {},
    extraReducers: {
        [fetchSYear.fulfilled.type]: (state, action) => {
            state.syears = action.payload;
            state.isLoaderYear = false;
        },
        [fetchSYear.pending.type]: (state) => {
            state.isLoaderYear = true;
        }
    }
});
export default yearSSlice.reducer;
